import React from "react";

const TableHeader = ({
  columns,
  editingHeader,
  editValue,
  setEditValue,
  setEditingHeader,
  finishEditing,
  onColumnResizeStart
}) => {
  return (
    <tr>
      {columns.map((col, colIndex) => {
        const editing = editingHeader === colIndex;
        
        return (
          <th
            key={col.id}
            className="excel-th"
            style={{
              minWidth: `${col.width || 120}px`,
              width: `${col.width || 120}px`,
              position: 'relative'
            }}
          >
            {editing ? (
              <input
                autoFocus
                value={editValue}
                onChange={e => setEditValue(e.target.value)}
                onBlur={finishEditing}
                onKeyDown={e => {
                  if (e.key === "Enter") finishEditing();
                  if (e.key === "Escape") finishEditing();
                }}
                className="excel-input"
                style={{
                  fontWeight: '600',
                  textAlign: colIndex === 0 ? 'left' : 'right'
                }}
              />
            ) : (
              <div
                className="excel-text"
                style={{
                  fontWeight: '600',
                  textAlign: colIndex === 0 ? 'left' : 'right',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
                onDoubleClick={() => setEditingHeader(colIndex)}
              >
                {col.label}
              </div>
            )}
            
            {/* Column Resizer */}
            <div
              className="column-resizer"
              onMouseDown={(e) => onColumnResizeStart(e, colIndex)}
              title="Drag to resize column"
            />
          </th>
        );
      })}
    </tr>
  );
};

export default TableHeader;